import React from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useUser } from "@clerk/clerk-react";
import { axios } from "../services";

import CourseCard from "../components/NewCourseCard";
import { RecentlyViewed, AdminCourses } from "../components/home";
import { Create } from "../features/course/components";
import { ScrollArea } from "../components/ui/scroll-area";

function Courses() {
  const { user } = useUser();
  const location = useLocation();

  const initialData = location.state?.data || [];

  const {
    data: courses = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["courses", user?.id],
    queryFn: async () => {
      const { data } = await axios.get(`/course/all/${user?.id}`);
      return data?.data || [];
    },
    enabled: !!user?.id,
    initialData: initialData?.length > 0 ? initialData : undefined,
  });

  return (
    <ScrollArea className="flex-1 h-full">
      <div className="container my-4 space-y-8">
        {/* <Create>Learn a new Topic</Create> */}
        <RecentlyViewed />
        {/* All Courses */}
        <div className="my-4">
          <h2 className="font-bold text-lg">Your Courses</h2>
        </div>
        {isLoading ? (
          <p className="text-center">Loading courses...</p>
        ) : isError ? (
          <p className="text-center text-red-500">Failed to load courses.</p>
        ) : courses.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {courses.map((course) => (
              <div key={course?.course?._id || course?._id}>
                <CourseCard
                  course={course?.course || course}
                  viewed={course?.viewedAt}
                />
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center">No courses available.</p>
        )}

        <AdminCourses />
      </div>
    </ScrollArea>
  );
}

export default Courses;
